// Imports ------------------------------------------------------------------->
import { Service, service } from './di'

// Private Definitions ------------------------------------------------------->

// Public Definitions -------------------------------------------------------->

// Hack to filter out merchants on the front end. This is required because certain
// flyers are not to be displayed in web, but there is no "hide_in_web" flag
// in fadmin. We also allow distribution to pass in blacklisted merchant ids
// (via blacklist_merchant_ids=234,112 URL param)

@service('BlacklistService')
export class BlacklistService extends Service {
    private _blacklistedMerchants: number[] = [
        5448, // Smuckers CPG - see FW-1376
    ]

    addBlacklistedMerchants(merchantIds: number[]) {
        this._blacklistedMerchants =
            this._blacklistedMerchants.concat(merchantIds)
    }

    isMerchantBlacklisted(merchantId: number) {
        return this._blacklistedMerchants.indexOf(merchantId) !== -1
    }

    getBlacklist() {
        return [].concat(this._blacklistedMerchants)
    }
}
